import {Controller} from 'react-hook-form'
import {FormControlLabel, Switch} from '@mui/material'

const FormSwitch = ({name, label, control, rules, required, disabled}) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules || {required}}
            render={({field: {onChange, value}}) => (
                <FormControlLabel
                    sx={{alignSelf: 'flex-start', mt: 2}}
                    control={
                        <Switch
                            onChange={onChange}
                            checked={value || false}
                            disabled={disabled}
                        />
                    }
                    label={label}
                />
            )}
        />
    )
}

export default FormSwitch
